// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".features.features-neu[data-v-195c20fc]{margin-top:3rem!important}.features.features-neu .caret-right[data-v-195c20fc]{color:var(--red)!important}.features.features-neu .skill-item.d-flex[data-v-195c20fc]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
